import { render, staticRenderFns } from "./EscalateDialog.vue?vue&type=template&id=86c5a886&"
import script from "./EscalateDialog.vue?vue&type=script&lang=ts&"
export * from "./EscalateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports